import { MDButton } from "@/components/atoms/MDButton";
import { IMedia } from "@/interfaces/media.interface";
import { CurrentChatMessages } from "@/messages/chat/current-chat.messages";

interface ButtonProps {
  media: IMedia;
  messages: CurrentChatMessages;
}

const ButtonMedia: React.FC<ButtonProps> = ({ media, messages }) => {
  const { openLink } = messages;

  return (
    <MDButton onClick={() => window.open(media.phisicalAddress, "_blank")}>{openLink}</MDButton>
  );
};

export default ButtonMedia;
